import React, { useState, useEffect } from "react";
import "./Track-order.css";
import "../../assets/css/modal.css";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { trackOrder } from "../../actions/productActions";
import SingleOrder from "./SingleOrder";
import OrderLoader from "../../common/OrderLoader";
import image4 from "../../assets/images/trackorder.jpg";
import Pusher from "pusher-js";
//import Pagination from "rc-pagination";
//import "rc-pagination/assets/index.css";

const TrackOrder = (props) => {
  const [page, setPage] = useState(1);
  const [orders, setOrders] = useState([]);
  //const elements = [] 
  const [hasPickUpOrder, setHasPickUpOrder] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const limit = 5;
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);


  const debouncedSearch = useDebounce(searchValue, 800);



  // Debounce function
  function useDebounce(value, delay = 800) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebouncedValue(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debouncedValue;
  }

  // Fetch orders
  useEffect(() => {
    let ignore = false;
    setIsFetching(true); // local loader

    // Only show global loader for first page
    const useGlobalLoader = false;

    props
      .trackOrder(page, limit, debouncedSearch || "", useGlobalLoader)
      .then((response) => {
        if (ignore) return;
        const newOrders = response?.data?.sells || [];

        if (newOrders.length < limit) setHasMore(false);

        setOrders((prevOrders) =>
          page === 1 ? newOrders : [...prevOrders, ...newOrders]
        );

        setIsFetching(false);
      })
      .catch(() => setIsFetching(false));

    return () => {
      ignore = true;
    };
  }, [page, debouncedSearch]);

  // Infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      if (isFetching || !hasMore) return;

      if (
        window.innerHeight + document.documentElement.scrollTop + 100 >=
        document.documentElement.offsetHeight
      ) {
        setPage((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFetching, hasMore]);

  // Reset orders on new search
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    setOrders([]);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [debouncedSearch]);

  // Render orders
  let elements;
  if (isFetching && page === 1 && orders.length === 0) {
    // Show loader on first load
    elements = (
      <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
        }}
      >
        <div>
          <OrderLoader />
        </div>


      </div>
    );
  } else if (orders.length > 0) {
    // Show orders
    elements = orders.map((order, i) => {
      if (!hasPickUpOrder && order?.type_for_api !== "Delivery") {
        setHasPickUpOrder(true);
      }
      return (
        <SingleOrder
          key={order.id || i}
          order={order}
          cartDetails={props.getCartDetails}
        />
      );
    });
  } else {
    // Show no orders message
    elements = (
      <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          width: "100%",
        }}
      >
        <img
          src="https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f6d2.svg"
          alt="No orders"
          style={{ width: "160px", height: "160px", marginBottom: "24px", opacity: 0.85 }}
        />
        <h4 style={{ color: "#2a2a2a", fontWeight: 700, marginBottom: "8px" }}>
          No Orders Yet
        </h4>
        <p style={{ color: "#9a9a9a", fontSize: "15px", maxWidth: "280px" }}>
          No pending order at this moment. Your orders will appear here once placed.
        </p>
      </div>
    );
  }

  useEffect(() => {
    Pusher.logToConsole = true;
    const pusher = new Pusher("e2ff0dec7200ebd67653", {
      cluster: "ap1",
      forceTLS: true
    });

    const channel = pusher.subscribe("test-channel");

    channel.bind("test-event", function (data) {
      console.log("Pusher Update Received in TrackOrder:", data);

      if (
        data?.message &&
        localStorage.getItem("location_id") === String(data.location_id) &&
        localStorage.getItem("business_id") === String(data.business_id)
      ) {
        console.log("Checking orders for ID:", data.order_id);

        setOrders(prevOrders => {
          const orderIndex = prevOrders.findIndex(
            order => String(order.id) === String(data.id)
          );

          if (orderIndex !== -1) {
            console.log("✅ Found order at index:", orderIndex);

            const updatedOrders = [...prevOrders];
            updatedOrders[orderIndex] = {
              ...updatedOrders[orderIndex],
              lalamove_status: data.status || updatedOrders[orderIndex].lalamove_status,
              estimated_arrival_time: data.estimated_arrival_time || updatedOrders[orderIndex].estimated_arrival_time,
              lalamove_driver_info: data.driver_info || updatedOrders[orderIndex].lalamove_driver_info,
              d_address: data.d_address || updatedOrders[orderIndex].d_address,
              paymentType: data.paymentType || updatedOrders[orderIndex].paymentType,
              last_4_card_digits: data.last_4_card_digits || updatedOrders[orderIndex].last_4_card_digits,
              business_location_mobile_for_delivery: data.business_location_mobile_for_delivery || updatedOrders[orderIndex].business_location_mobile_for_delivery,
              pickup_completed: data.pickup_completed !== undefined ? data.pickup_completed : updatedOrders[orderIndex].pickup_completed,
            };

            return updatedOrders;
          } else {
            console.log("Order not found in current page");
            return prevOrders;
          }
        });
      }
    });

    return () => {
      channel.unbind_all();
      pusher.unsubscribe("test-channel");
      pusher.disconnect();
    };
  }, []);

  return (
    <div>
      {/* Search Bar */}
      <div className="search-bar-section">
        <div className="search-bar-layout">
          <input
            type="text"
            className="search-input"
            placeholder="Search order..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
      </div>
      {/* <Pagination
                className="custom-pagination"
                current={page}
                total={props.total_orders || 0}
                pageSize={5}
                onChange={(pageNumber) => setPage(pageNumber)}
              />
                showTotal={(total, range) => `Showing ${range[0]}–${range[1]} of ${total}`}
              />*/}

      {/* Orders */}
      {elements}

      {/* Bottom Loader for infinite scroll */}
      {page > 1 && isFetching && hasMore && (
        <div style={{ textAlign: "center" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div
              style={{
                // marginBottom: "10px",
                paddingTop: "50px",   // top padding
                paddingBottom: "30px", // smaller bottom padding
                paddingLeft: "0",
                paddingRight: "0",
                lineHeight: 0,
                height: "40px",
                width: "94%",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTop: '9px solid #e8e6e6ff',
              }}
            >
              <OrderLoader text="" color="#ff0000" size={60} />
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

const mapStateToProps = (state) => ({
  order: state.products.track_order,
  total_orders: state.products.total_orders,
  loader: state.products.loader,
});

export default withTranslation()(
  connect(mapStateToProps, { trackOrder })(TrackOrder)
);